// extracted by mini-css-extract-plugin
export default {"education_wrapper":"Education_education_wrapper__0Ktx2","title":"Education_title__NVzVB","main_info":"Education_main_info__Ut0Tr","link":"Education_link__vgT-j"};